import { jsx as o, jsxs as S } from "react/jsx-runtime";
import { useCallback as $ } from "react";
import { AutoCompleteInput as g } from "./index.es2472.js";
import { Combobox as A } from "@headlessui/react";
import { FieldSizeToNumber as v } from "./index.es5575.js";
import p from "./index.es2470.js";
import N from "classnames";
import { useTheme as j } from "./index.es190.js";
import { DrawerTemplate as k } from "./index.es122.js";
import { FlexContainer as z } from "./index.es584.js";
const G = (c) => {
  const {
    isTooZoomedForDropdowns: u,
    setOpen: t,
    value: d,
    onAutoCompleteSearch: h,
    onAutocompleteClear: x,
    onFocus: C,
    autoCompleteContent: r,
    chipsInfo: n,
    testId: i,
    size: f,
    maxMenuHeight: m,
    menuWidth: w,
    menuTopPx: D,
    inputWidth: b,
    open: a,
    hasItems: I
  } = c, y = $(
    (s) => s.key === "Escape" && t(!1),
    [t]
  ), { spacings: O } = j(), T = n ? a : a && I;
  let l = null;
  if (T) {
    const s = {
      "--top": `${v[f] + 6 + D}px`,
      "--width": `${w ?? b}px`,
      "--maxHeight": m ? `${m}px` : "unset"
    }, F = N(
      p["combobox-menu"],
      { [p.hasChips]: !!n },
      { [p.noChips]: !n }
    );
    l = /* @__PURE__ */ o("div", { role: "presentation", tabIndex: -1, onKeyDown: y, children: u ? /* @__PURE__ */ S(
      k,
      {
        isOpen: !0,
        setIsOpen: t,
        header: { title: "Select an Option", actionType: "close-help" },
        testId: `${i}-drawer-version`,
        width: "100%",
        children: [
          /* @__PURE__ */ o(z, { padding: O.md, children: /* @__PURE__ */ o(
            g,
            {
              setValue: h,
              value: d,
              onClear: x,
              ref: (e) => e == null ? void 0 : e.focus(),
              onFocus: (e) => {
                C(e);
              }
            }
          ) }),
          r
        ]
      }
    ) : /* @__PURE__ */ o(
      A.Options,
      {
        as: "span",
        className: F,
        static: !0,
        "data-testid": `${i}-options-menu`,
        style: s,
        children: r
      }
    ) });
  }
  return l;
};
export {
  G as AutocompleteDropDownSection
};
//# sourceMappingURL=index.es2475.js.map
